export const foundationTokens = {
  spacing: {
    unit: 4
  },
  radius: {
    control: 8,
    surface: 12,
    overlay: 14
  },
  shadow: {
    surface: 1,
    floating: 6,
    modal: 9
  }
} as const
